import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelForLegacyChip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status chip label shown next to an account when it is on the legacy (v3) experience */
            labelForLegacyChip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountOption.labelForLegacyChip?c=kkosl0vta0l5", defaultMessage: "LEGACY" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
